/**
 * Production-safe logger utility.
 *
 * Only logs messages in development environment.
 * In production, all logs are silenced except errors.
 */

const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },

  info: (...args) => {
    if (isDev) console.info(...args);
  },

  warn: (...args) => {
    if (isDev) console.warn(...args);
  },

  debug: (...args) => {
    if (isDev) console.debug(...args);
  },

  // Errors always log (important for debugging production issues)
  error: (...args) => {
    console.error(...args);
  },
};

export default logger;
